const forms = [
  {
    name: "GRN",
    className: "bg-white p-4 rounded-md p-8 w-[100%] mx-auto",
    options: [
      {
        name: "Supplier",
        type: "selectandadd",  
        path: "/app/suppliers/add",
        form: {
          name: "supplier",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Supplier",
          api: "get-all-suppliers",
          options: null,
          value: null,
          required: true,
        },
      },
      {
        name: "Number",
        type: "select",
        form: {
          type: "text",
          name: "number",
          placeholder: "Purchase order number",
          api: "get-all-lpos",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          options: null,
          value: null,
          required: true,
        },
      },
      {
        name: "Invoice",
        type: "input",
        form: {
          type: "text",
          name: "invoice",
          placeholder: "Supplier invoice number",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Date",
        type: "date",
        form: {
          type: "text",
          name: "date",
          placeholder: "Purchase order date",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Due Date",
        type: "due_date",
        form: {
          type: "text",
          name: "due_date",
          placeholder: "Purchase order due date",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "In-active",
            },
          ],
          required: false,
        },
      },
    ],
  },
];

export default forms;
